<template>
    <div
      class="modal fade createNewModal"
      id="AddElementModal"
      tabindex="-1"
      ref="addElementModalRef"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content p-15 p-md-40">
          <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
            <h5 class="modal-title fw-bold text-black">{{ title }}</h5>
          </div>
          <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
            <Form ref="elementForm" @submit="addElement" :validation-schema="elementSchema">
                
                <div class="row">

                  <div class="col-md-4">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                      Code <span class="text-danger">*</span>
                      </label>
                      <Field name="code" type="text" 
                      class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le code"/>
                      <ErrorMessage name="code" class="text-danger"/>
                  </div>
                  </div>

                  <div class="col-md-4">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                      Nom <span class="text-danger">*</span>
                      </label>
                      <Field name="nom" type="text" 
                      class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le nom"/>
                      <ErrorMessage name="nom" class="text-danger"/>
                  </div>
                  </div>

                  <div class="col-md-4">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                      Prénoms <span class="text-danger">*</span>
                      </label>
                      <Field name="prenoms" type="text" 
                      class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le prénoms"/>
                      <ErrorMessage name="prenoms" class="text-danger"/>
                  </div>
                  </div>

                  <div class="col-md-6">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                      Téléphone <span class="text-danger">*</span>
                      </label>
                      <Field name="telephone" type="text" 
                      class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le télephone"/>
                      <ErrorMessage name="telephone" class="text-danger"/>
                  </div>
                  </div>

                  <div class="col-md-6">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                      Quartier <span class="text-danger">*</span>
                      </label>
                      <Field name="quartier" type="text" 
                      class="form-control shadow-none fs-md-15 text-black" placeholder="Quel est votre quartier"/>
                      <ErrorMessage name="quartier" class="text-danger"/>
                  </div>
                  </div>

                  <div class="col-md-6">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Sexe <span class="text-danger">*</span>
                      </label>
                      <Field name="sexe" v-model="sexeSelected"  v-slot="{ field }">
                        <Multiselect
                            v-model = "field.value"
                            v-bind = "field"
                            :options="sexeOptions"
                            :searchable="true"
                            placeholder="Rechercher un element"
                            noResultText= "Aucun enregistrement trouvé"
                            noOptionsText="Tapez au moins deux caractères"/>
                      </Field>
                      <ErrorMessage name="sexe" class="text-danger"/>
                  </div>
                  </div>

                  <div class="col-md-6">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Agent Affecté <span class="text-danger">*</span>
                      </label>
                      <Field name="agent" v-model="clientSelected"  v-slot="{ field }">
                        <Multiselect
                            v-model = "field.value"
                            v-bind = "field"
                            :options="clientOptions"
                            :searchable="true"
                            placeholder="Rechercher un element"
                            noResultText= "Aucun enregistrement trouvé"
                            noOptionsText="Tapez au moins deux caractères"/>
                      </Field>
                      <ErrorMessage name="agent" class="text-danger"/>
                  </div>
                  </div>

                  <div class="col-md-12">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                      Personne a contacté <span class="text-danger">*</span>
                      </label>
                      <Field name="personneContact" type="text" 
                      class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le nom  prenoms et contact "/>
                      <ErrorMessage name="personneContact" class="text-danger"/>
                  </div>
                  </div>

                  

                </div>
                
              
              <button
                class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
                type="submit">
                {{ btntext }}
              </button>
          </Form>
          </div>
          <button
            type="button"
            class="btn-close shadow-none"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="resetValue()"
          ></button>
        </div>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent, ref, watch, onMounted } from 'vue';
  import { Form, Field, ErrorMessage } from 'vee-validate';
  import ApiService from '../../services/ApiService';
  import * as Yup from 'yup';
  import { Client } from '../../models/Client';
  import { error , success, hideModal } from '../../utils/utils';
  import Multiselect from '@vueform/multiselect';
  
  export default defineComponent({
      name: "AddClientModal",
      components: {
      Form,
      Field,
      ErrorMessage,
      Multiselect
    },
    props: {
      item: {
        type: Number,
        default: 0,
      }
    },
    setup(props, { emit }){
      const elementSchema = Yup.object().shape({
        code: Yup.string().required('Le code est obligatoire'),
        nom: Yup.string().required('Le nom est obligatoire'),
        prenoms: Yup.string().required('Le prenoms est obligatoire'),
        telephone: Yup.string().required('Le numero de téléphone est obligatoire'),
        quartier: Yup.string().required('Le quartier est obligatoire'),
        personneContact: Yup.string().required('La personne a contacté est obligatoire'),
        estAgent: Yup.boolean(),
      });
  
      
      const elementForm = ref<Client | null>(null);
      const addElementModalRef = ref<null | HTMLElement>(null);
      const sexeSelected = ref(null);
      const clientSelected = ref(null);
      const clientOptions = ref([]);

      const  sexeOptions =  [
        { value: 'Homme', label: 'Masculin' }, 
        { value: 'Femme', label: 'Feminin'}
      ];
      
      const isUPDATE = ref(false);
      const title = ref("Ajouter un client");
      const btntext = ref('Enregistrer');
  
      watch(() => props.item, (newValue) => {
        getOne(newValue);
        isUPDATE.value = true;
        btnTitle();
      });
  
      const btnTitle = async () => {
        if (isUPDATE.value) {
           title.value = "Modifier le client";
           btntext.value = "Modifier";
        }else{
           title.value = "Ajouter un client";
           btntext.value = "Enregistrer";
        }
      }
  
      const produitsError = ref(false); 
  
     
      const getOne = async (id: number) => {
        return ApiService.get("/client/"+id)
        .then(({ data }) => {
          // map data in form
          const donnees = data.data;
          for (const key in donnees) {
            elementForm.value?.setFieldValue(key, 
            (typeof donnees[key] === 'object' && donnees[key] !== null)? donnees[key].id :donnees[key]
            );
          }
          emit('openmodal', addElementModalRef.value);
  
        })
        .catch(({ response }) => {
          error(response.data.message)
        });
      }

      const fetchAgents = async () => {
            ApiService.get("/utilisateurs/agent")
            .then(({ data }) => {
              clientOptions.value = data.data.map((p) => {
                return { 
                  value: p.id,
                  label: p.nom +' '+ p.prenoms,
                }
            });
            console.log('agent',clientOptions.value);
            })
            .catch(({ response }) => {
            // produitsError.value = true;
            });
        };
  
      const addElement = async (values: any, elementForm) => {
        console.log(values);
        values = values as Client;
        if(isUPDATE.value){
          ApiService.put("/client/"+values.id,values)
          .then(({ data }) => {
              if(data.code == 200) { 
                success(data.message);
                elementForm.resetForm();
                hideModal(addElementModalRef.value);
                isUPDATE.value=false;
                btnTitle();
                emit('close');
              }
          })
          .catch(({ response }) => {
              error(response.data.message);
          });
        }else{
          console.log('values',values);
          ApiService.post("/client",values)
          .then(({ data }) => {
              if(data.code == 201) { 
                success(data.message);
                elementForm.resetForm();
                hideModal(addElementModalRef.value);
                emit('close');
              }
          })
          .catch(({ response }) => {
              error(response.data.message);
          });
        }
      };
     
  
      onMounted(() => {
        fetchAgents();
      });
  
      const resetValue = () => {
        const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
          isUPDATE.value=false;
        formFields.forEach(field => {
          field.value = '';
        });
        btnTitle()
      };
  
      return { 
        elementSchema,
        addElementModalRef,
        addElement,
        elementForm,
        title,btntext,
        resetValue,
        produitsError,
        sexeOptions,
        sexeSelected,
        clientSelected,
        clientOptions
      };
    },
  });
  </script>